import React, { useEffect, useRef, useState } from "react"

import useSmartCrop from "@/hooks/useSmartCrop"
import useIsSsr from "@/hooks/useIsSsr"
import Image from "next/image"
const DynamicImage = ({
  imgUrl = "",
  alt = "",
  className = "",
  uniqueId = "",
  urlModifiers = "",
  priority = false,
  ...restProps
}) => {
  const smartCrop = useSmartCrop()
  const isSsr = useIsSsr()
  const cropedImage = useRef(null)
  const imgPlaceholder =
    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
  const isScene7Img = imgUrl?.includes("scene7")
  const [bgColorImage, setBgColorImage] = useState("")
  const [imageUrl, setImageUrl] = useState(imgUrl)

  useEffect(() => {
    if (
      !isSsr &&
      smartCrop.scriptStatus &&
      isScene7Img &&
      window.s7responsiveImage
    ) {
      smartCrop.applySmartCrop(cropedImage.current)
    }
  }, [
    smartCrop.scriptStatus,
    imgUrl,
    window.s7responsiveImage,
    uniqueId,
    isSsr,
  ])

  useEffect(() => {
    if (urlModifiers && imgUrl) {
      setBgColorImage(
        imgUrl?.includes("?")
          ? `${imgUrl}&${urlModifiers}`
          : `${imgUrl}?${urlModifiers}`
      )
    }
  }, [imgUrl, urlModifiers])

  const getDefaultImgUrl = () =>{
    setImageUrl(imgPlaceholder)
  }
  const DEFAULT_IMG_PLACEHOLDER =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiM5OTk5OTkiIC8+PC9zdmc+";


  return (
    <img
      ref={cropedImage}
      src={imgPlaceholder}
      data-src={urlModifiers ? bgColorImage : imgUrl}
      // onError={e => getDefaultImgUrl(e)}
      // src={urlModifiers ? bgColorImage : imageUrl}
      // data-src={imgPlaceholder}
      data-mode="smartcrop"
      alt={alt}
      // blurDataURL={DEFAULT_IMG_PLACEHOLDER}
      // placeholder="blur"
      // height={1000}
      // width={1000}
      // priority
      className={className}
      key={uniqueId}
      {...restProps}
    />
  )
}

export default DynamicImage
